import { useState, useEffect } from "react";
import _isEmpty from "lodash/isEmpty";

// Utils
import { getConnector } from "utils/connectors";

// Types
import { NetworkConfigType } from "config/network/types";

export const useLedgerApp = (config: NetworkConfigType) => {
  const [isLedgerApp, setLedgerApp] = useState(false);
  const [isCheckingLedger, setChecking] = useState(true);

  useEffect(() => {
    if (!_isEmpty(config)) {
      try {
        const ledgerLiveConnector = getConnector("ledgerLive", config);

        setLedgerApp(ledgerLiveConnector.isLedgerApp());
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log("error checking ledger app :", e);
      } finally {
        setChecking(false);
      }
    }
  }, [config]);

  return { isLedgerApp, isCheckingLedger };
};

export default useLedgerApp;
